import { InputContext, inputContextToColor } from '../InputContext';
import { Colors } from '../../../ui/vars';
import { css } from '@emotion/css';
import React from 'react';
import { Typo } from '../../../ui/typo.ts';

interface Props {
    text: React.ReactNode;
    rightText?: React.ReactNode;
    elevated: boolean;
    context: InputContext;
    focused?: boolean;
    hidden?: boolean;
    key?: string;
    hideHeight?: number;
    marginBottom?: boolean;
}

function getLabelColor(p: { elevated: boolean; context: InputContext }) {
    const opacity = 0.7;
    return Colors.rgba(inputContextToColor(p.context), opacity);
}

export function Label({
    text,
    rightText,
    elevated,
    context,
    hidden,
    hideHeight,
    marginBottom,
}: Props) {
    if (!text) {
        return null;
    }
    const LabelStyles = css({
        position: 'relative',
        whiteSpace: 'nowrap',
        display: 'block',
        cursor: 'default',
        height: '18px',
        overflow: 'visible',
        [`@media(max-height: ${hideHeight || 0}px)`]: elevated
            ? {
                  display: 'none',
              }
            : null,
        marginBottom: marginBottom ? '12px' : undefined,
    });
    const typo = elevated ? Typo.captionC4 : Typo.body;
    return (
        <label className={LabelStyles}>
            <div
                className={css({
                    display: 'block',
                    position: 'absolute',
                    width: '100%',
                    top: elevated ? '0' : '18px',
                    visibility: hidden ? 'hidden' : 'visible',
                    cursor: elevated ? 'default' : 'text',
                    color: getLabelColor({ elevated, context }),
                    ...typo,
                })}
            >
                {rightText && (
                    <div className={css({ float: 'right' })}>{rightText}</div>
                )}
                <div>{text}</div>
            </div>
        </label>
    );
}

export const Factory = (
    props: Props,
    ...children: React.ReactNode[]
): React.ReactElement => React.createElement(Label, props, ...children);
